import type { DefectCatalogItem } from '../contracts/availableLayers';

import { getPotholeCatalogDefects } from './potholeCatalog';

export function mergePotholeCatalogDefects(
  defects: readonly DefectCatalogItem[],
  surveyTypes?: readonly string[],
): readonly DefectCatalogItem[] {
  const surveyTypeFilters = (surveyTypes ?? [])
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);

  const potholeDefects =
    surveyTypeFilters.length === 0
      ? getPotholeCatalogDefects()
      : getPotholeCatalogDefects().filter((defect) =>
          surveyTypeFilters.includes(defect.surveyType.trim().toLowerCase()),
        );

  if (potholeDefects.length === 0) {
    return defects;
  }

  const bySlug = new Map<string, DefectCatalogItem>();
  for (const defect of defects) {
    bySlug.set(String(defect.slug), defect);
  }
  for (const pothole of potholeDefects) {
    bySlug.set(String(pothole.slug), pothole);
  }
  return Array.from(bySlug.values());
}
